var React = require('react');

function Power (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"currentColor","d":"M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C18.05 7.906 19.004 9.897 19 12c0 3.87-3.13 7-7 7-2.96.002-5.602-1.86-6.594-4.65-.993-2.789-.122-5.901 2.174-7.77L6.17 5.17C4.158 6.868 2.999 9.367 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H24V24H0z","key":1})]));
}

Power.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Power;

Power.default = Power;
